import { defineStore } from 'pinia';
import SwiperClass from 'swiper';
import { ref } from 'vue';

export const useSwiperStore = defineStore('swiper', () => {
  const gnb = ref<SwiperClass>();
  const gnbScroll = ref<SwiperClass>();
  const toppingGroupSwiper = ref<SwiperClass>();

  const setMenuGroupSwiper = (swiper: SwiperClass) => {
    gnb.value = swiper;
  };

  const setMenuGroupScroll = (swiper: SwiperClass) => {
    gnbScroll.value = swiper;
  };

  const setToppingGroupSwiper = (swiper: SwiperClass) => {
    toppingGroupSwiper.value = swiper;
  };

  return { gnb, gnbScroll, toppingGroupSwiper, setMenuGroupSwiper, setMenuGroupScroll, setToppingGroupSwiper };
});
